import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=19a1b2c0&scoped=true&"
import script from "./QuotationForm.vue?vue&type=script&lang=js&"
export * from "./QuotationForm.vue?vue&type=script&lang=js&"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&id=19a1b2c0&lang=scss&scoped=true&"
import style1 from "./QuotationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1b2c0",
  null
  
)

export default component.exports